import type { TFunction } from 'i18next';

import { ApiErrorEnum } from '../../enums/ApiErrorEnum';
import { getApiErrorCode } from '../apiErrorCode/apiErrorCode';

/** httpClient-normalized errors expose the API payload on `error.response`. */
export function getFolderPasswordErrorResponse(error: unknown): unknown {
  return (error as { response?: unknown }).response;
}

const FOLDER_PASSWORD_ERROR_I18N_KEYS: Record<string, string> = {
  [ApiErrorEnum.FolderPasswordPasswordRequired]: 'errors.folderPassword.passwordRequired',
  [ApiErrorEnum.FolderPasswordTooShort]: 'errors.folderPassword.tooShort',
  [ApiErrorEnum.FolderPasswordNotAFolder]: 'errors.notAFolder',
  [ApiErrorEnum.FolderPasswordOwnerOnly]: 'errors.folderPassword.ownerOnly',
  [ApiErrorEnum.FolderPasswordAlreadyExists]: 'errors.folderPassword.alreadyExists',
  [ApiErrorEnum.FolderPasswordAncestorProtected]: 'errors.folderPassword.ancestorProtected',
  [ApiErrorEnum.FolderPasswordDescendantProtected]: 'errors.folderPassword.descendantProtected',
  [ApiErrorEnum.FolderPasswordExpirationInPast]: 'errors.dateMustBeFuture',
  [ApiErrorEnum.FolderPasswordNotSet]: 'errors.folderPassword.notSet',
  [ApiErrorEnum.FolderPasswordNotProtected]: 'errors.folderPassword.notProtected',
  [ApiErrorEnum.FolderPasswordCurrentRequired]: 'errors.folderPassword.currentRequired',
  [ApiErrorEnum.FolderPasswordExpired]: 'errors.folderPassword.expired',
  [ApiErrorEnum.FolderPasswordIncorrect]: 'errors.folderPassword.incorrect',
  [ApiErrorEnum.FolderPasswordSessionNotFound]: 'errors.folderPassword.sessionNotFound',
  [ApiErrorEnum.FolderPasswordSessionForbidden]: 'errors.folderPassword.sessionForbidden',
  [ApiErrorEnum.FolderPasswordOtpNotRequested]: 'errors.folderPassword.otpNotRequested',
  [ApiErrorEnum.FolderPasswordOtpRateLimited]: 'modal.resetFilePasswordForm.tooManyOtpRequests',
  [ApiErrorEnum.FolderPasswordOtpLockedOut]:
    'modal.resetFilePasswordForm.tooManyAttemptsRequestNewOtp',
  [ApiErrorEnum.FolderPasswordOtpExpired]: 'modal.resetFilePasswordForm.codeExpiredRequestNewOtp',
  [ApiErrorEnum.Unauthorized]: 'errors.unauthorized',
  [ApiErrorEnum.ObjectNotFound]: 'errors.genericError',
};

/**
 * Resolves a user-facing message for folder-password API errors (plain string codes or object payloads).
 */
export function resolveFolderPasswordApiErrorMessage(error: unknown, t: TFunction): string {
  const code = getApiErrorCode(getFolderPasswordErrorResponse(error));
  if (code) {
    const i18nKey = FOLDER_PASSWORD_ERROR_I18N_KEYS[code];
    if (i18nKey) {
      return t(i18nKey);
    }
  }
  return t('errors.serverError');
}
